import { render } from "./resultCard.vue?vue&type=template&id=74b41843&scoped=true&ts=true&lang=pug"
import script from "./resultCard.vue?vue&type=script&lang=ts"
export * from "./resultCard.vue?vue&type=script&lang=ts"

import "./resultCard.vue?vue&type=style&index=0&id=74b41843&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b41843"]])

export default __exports__